import dayjs from 'dayjs';

const getHourlyHeatmap = (data:Array<any>, initialDate: any, endDate: any ) => {
    const totalHours = dayjs(endDate).diff(dayjs(initialDate), 'hour') + 1

    const heatmapData:Array<any> = []
    const amounts:Array<number> = []

    const nonZeroDates = new Set()
    for (const timeData of data) {
        const date = dayjs(timeData.date).format("YYYY-MM-DD HH")
        const count = timeData.total_count;
        const amount = (timeData.total_amount).toFixed(2);
        nonZeroDates.add(date)
        heatmapData.push({ date, count, amount, level: 0 })
        if (timeData.amount > 0) {
            amounts.push(timeData.amount);
        }
    }

    const amountsQuarter = amounts.length / 4
    heatmapData.sort((a, b) => Number(a.amount) > Number(b.amount) ? -1 : 1);

    let cummulativeDesc = 0
    let rank = 4
    for (let i = 0; i < heatmapData.length; i++) {
      cummulativeDesc += heatmapData[i].amount;

      heatmapData[i].level = rank;
      
      if (cummulativeDesc >= amountsQuarter && rank > 1) {
        rank -= 1;
        cummulativeDesc = 0;
      }
    }

    for (let i = 0; i < totalHours; i++) {
        const date = dayjs(initialDate).add(i, 'day').format("YYYY-MM-DD HH")
        if (!nonZeroDates.has(date)) {
            heatmapData.push({ date, count: 0, amount: 0, level: 0 });
        }
    }

    return heatmapData;
  }

const getDailyHeatmap = (data:Array<any>, initialDate: any, endDate: any, ) => {
    const totalDays = dayjs(endDate).diff(dayjs(initialDate), 'day') + 1

    const heatmapData:Array<any> = []
    const amounts:Array<number> = []

    const nonZeroDates = new Set()
    for (const timeData of data) {
        const date = dayjs(timeData.date).format("YYYY-MM-DD")
        const count = timeData.total_count;
        const amount = (timeData.total_amount).toFixed(2);
        nonZeroDates.add(date)
        heatmapData.push({ date, count, amount, level: 0 })
        if (timeData.amount > 0) {
            amounts.push(timeData.amount);
        }
    }

    const amountsQuarter = amounts.length / 4

    heatmapData.sort((a, b) => Number(a.amount) > Number(b.amount) ? -1 : 1);

    let cummulativeDesc = 0
    let rank = 4
    for (let i = 0; i < heatmapData.length; i++) {
      cummulativeDesc += heatmapData[i].amount;

      heatmapData[i].level = rank;
      
      if (cummulativeDesc >= amountsQuarter && rank > 1) {
        rank -= 1;
        cummulativeDesc = 0;
      }
    }

    for (let i = 0; i < totalDays; i++) {
        const date = dayjs(initialDate).add(i, 'day').format("YYYY-MM-DD")
        if (!nonZeroDates.has(date)) {
            heatmapData.push({ date, count: 0, amount: 0, level: 0 });
        }
    }

    return heatmapData;
  }

const getTimeHeatmap = (data:Array<any>, initialDate: any, endDate: any, granularity: string) => {
    switch (granularity) {
        case 'hourly':
            return getHourlyHeatmap(data, initialDate, endDate);
        case 'daily':
            return getDailyHeatmap(data, initialDate, endDate);
        default:
            return getDailyHeatmap(data, initialDate, endDate);
        }
}

export default getTimeHeatmap;